import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJCELogs.css';

function DJCPLogs({ tableData }) {
    return (
        <div className="DJCE_logs-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No hay registros</h4>
            )}
        </div>
    );
}

export default DJCPLogs;
